import * as types from "./types";
import { ITEMS_PER_PAGE } from "../../network/apis/companies";

const INITIAL_STATE = {
  list: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    total: 0,
    per_page: ITEMS_PER_PAGE,
    pages: 0,
    currentPage: 1,
  },
  filters: {
    search: "",
    status: [],
    created_at_start_date: null,
    created_at_end_date: null,
  },
  editDrawerOpen: false,
  editDrawerCompanyId: null,
  updateLoading: false,
  companyEditRequestDetail: null,
  companyEditRequestDetailLoading: false,
  companyEditRequestDetailError: null,
  companyEditRequestPatchSubmitting: false,
};

const companiesList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_COMPANIES_LIST_REQUEST:
      return { ...state, loading: true, error: null };

    case types.GET_COMPANIES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        list: action.payload.list,
        pagination: {
          ...state.pagination,
          pages: action.payload.meta.pages,
          currentPage: action.payload.meta.currentPage,
          total: action.payload.meta.count,
        },
      };

    case types.GET_COMPANIES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload?.error ?? "An error occurred",
      };

    case types.SET_COMPANIES_LIST_SEARCH:
      return {
        ...state,
        filters: { ...state.filters, search: action.payload },
        pagination: { ...state.pagination, page: 1 },
      };

    case types.SET_COMPANIES_LIST_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        pagination: { ...state.pagination, page: 1 },
      };

    case types.SET_COMPANIES_LIST_PAGE:
      return {
        ...state,
        pagination: { ...state.pagination, page: action.payload },
      };

    case types.SET_COMPANIES_LIST_PAGE_SIZE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: 1,
          per_page: action.payload,
        },
      };

    case types.OPEN_EDIT_COMPANY_DRAWER:
      return {
        ...state,
        editDrawerOpen: true,
        editDrawerCompanyId: action.payload?.id ?? null,
      };

    case types.CLOSE_EDIT_COMPANY_DRAWER:
      return { ...state, editDrawerOpen: false, editDrawerCompanyId: null };

    case types.UPDATE_COMPANY_REQUEST:
      return { ...state, updateLoading: true };

    case types.UPDATE_COMPANY_SUCCESS:
      return { ...state, updateLoading: false };

    case types.UPDATE_COMPANY_FAILURE:
      return { ...state, updateLoading: false };

    case types.GET_COMPANY_EDIT_REQUEST_SHOW_REQUEST:
      return {
        ...state,
        companyEditRequestDetailLoading: true,
        companyEditRequestDetailError: null,
        companyEditRequestDetail: null,
      };

    case types.GET_COMPANY_EDIT_REQUEST_SHOW_SUCCESS:
      return {
        ...state,
        companyEditRequestDetailLoading: false,
        companyEditRequestDetail: action.payload.data,
      };

    case types.GET_COMPANY_EDIT_REQUEST_SHOW_FAILURE:
      return {
        ...state,
        companyEditRequestDetailLoading: false,
        companyEditRequestDetailError:
          action.payload?.error ?? "An error occurred",
      };

    case types.CLEAR_COMPANY_EDIT_REQUEST_DETAIL:
      return {
        ...state,
        companyEditRequestDetail: null,
        companyEditRequestDetailLoading: false,
        companyEditRequestDetailError: null,
        companyEditRequestPatchSubmitting: false,
      };

    case types.PATCH_COMPANY_EDIT_REQUEST_REQUEST:
      return { ...state, companyEditRequestPatchSubmitting: true };

    case types.PATCH_COMPANY_EDIT_REQUEST_SUCCESS:
    case types.PATCH_COMPANY_EDIT_REQUEST_FAILURE:
      return { ...state, companyEditRequestPatchSubmitting: false };

    default:
      return state;
  }
};

export default companiesList;
